import { useTranslation } from "react-i18next";

import Tag from "@components/shared/Tag";

const DeclarationTypeTag: React.FunctionComponent<{ isEstimated: boolean }> = ({
  isEstimated,
}) => {
  const { t } = useTranslation();

  return (
    <Tag status={isEstimated ? "warning" : "success"}>
      {isEstimated ? t("declaration.estimated") : t("declaration.actual")}
    </Tag>
  );
};

export default DeclarationTypeTag;
